module.exports = __webpack_public_path__ + "img/1483854549.367ca7bf.jpg";